/** Verified live: KLIPY media renditions are served from these host suffixes. */
const KLIPY_CDN_SUFFIXES = [".klipy.com", ".klipy.co"];

/** Client-safe URL check. This module must not import server environment data. */
export function isKlipyCdnUrl(rawUrl: string): boolean {
  try {
    const url = new URL(rawUrl);
    if (url.protocol !== "https:") return false;
    return KLIPY_CDN_SUFFIXES.some(
      (suffix) =>
        url.hostname.endsWith(suffix) || url.hostname === suffix.slice(1),
    );
  } catch {
    return false;
  }
}
